"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalization = void 0;

var constants = _interopRequireWildcard(require("./constants"));

var _fetchHelper = require("@eig-builder/core-utils/helpers/fetch-helper");

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _currentLanguageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/current-language-helper"));

var _translationProductHelper = _interopRequireDefault(require("./../helpers/translation-product-helper"));

/**
 * Get Localtions from the server
 * use the GetCurrentLanguage helper to receive the correct language
 *
 * @returns promise, that will dispatch redux events
 */
var getLocalization = function getLocalization() {
  var language = (0, _currentLanguageHelper["default"])();
  var productName = (0, _translationProductHelper["default"])();

  if (typeof window !== "undefined" && window.runtimeTranslations) {
    return {
      type: constants.GET_LOCALIZATION_FROM_WINDOW,
      body: window.runtimeTranslations
    };
  }

  return (0, _fetchHelper.fetchAsJson)((0, _urlHelper.getUrl)(_urlHelper.siteNames.TRANSLATION, "/v1.0/translations?productName=".concat(productName, "&groupName=Javascript&language=").concat(language), {
    useCdn: true
  }), {
    key: constants.GET_LOCALIZATION
  });
};

exports.getLocalization = getLocalization;